import {
  CalculationStatus,
  InvitationStatus,
  LedgerTransactionType,
  MatchOutcome,
  MatchStatus,
  PlatformLedgerTransactionType,
  Role,
  RoundStatus,
  SettlementResultStatus,
  UserStatus,
} from '@robu/shared';

/** Semantic tone shared by Badge / StatusBadge. */
export type Tone = 'neutral' | 'brand' | 'accent' | 'positive' | 'negative' | 'caution';

export const MATCH_STATUS_LABELS: Record<MatchStatus, string> = {
  [MatchStatus.DRAFT]: 'Черновик',
  [MatchStatus.SCHEDULED]: 'Запланирован',
  [MatchStatus.OPEN]: 'Приём прогнозов',
  [MatchStatus.CLOSED]: 'Приём закрыт',
  [MatchStatus.RESULT_ENTERED]: 'Результат внесён',
  [MatchStatus.CALCULATED]: 'Рассчитан',
  [MatchStatus.CANCELLED]: 'Отменён',
};

export const MATCH_STATUS_TONES: Record<MatchStatus, Tone> = {
  [MatchStatus.DRAFT]: 'neutral',
  [MatchStatus.SCHEDULED]: 'neutral',
  [MatchStatus.OPEN]: 'brand',
  [MatchStatus.CLOSED]: 'caution',
  [MatchStatus.RESULT_ENTERED]: 'accent',
  [MatchStatus.CALCULATED]: 'positive',
  [MatchStatus.CANCELLED]: 'negative',
};

export const ROUND_STATUS_LABELS: Record<RoundStatus, string> = {
  [RoundStatus.DRAFT]: 'Черновик',
  [RoundStatus.ACTIVE]: 'Активен',
  [RoundStatus.COMPLETED]: 'Завершён',
};

export const ROUND_STATUS_TONES: Record<RoundStatus, Tone> = {
  [RoundStatus.DRAFT]: 'neutral',
  [RoundStatus.ACTIVE]: 'brand',
  [RoundStatus.COMPLETED]: 'accent',
};

export const USER_STATUS_LABELS: Record<UserStatus, string> = {
  [UserStatus.INVITED]: 'Приглашён',
  [UserStatus.ACTIVE]: 'Активен',
  [UserStatus.BLOCKED]: 'Заблокирован',
  [UserStatus.INACTIVE]: 'Неактивен',
};

export const USER_STATUS_TONES: Record<UserStatus, Tone> = {
  [UserStatus.INVITED]: 'caution',
  [UserStatus.ACTIVE]: 'positive',
  [UserStatus.BLOCKED]: 'negative',
  [UserStatus.INACTIVE]: 'neutral',
};

export const ROLE_LABELS: Record<Role, string> = {
  [Role.PLAYER]: 'Игрок',
  [Role.ADMINISTRATOR]: 'Администратор',
  [Role.SUPER_ADMINISTRATOR]: 'Супер-администратор',
};

export const INVITATION_STATUS_LABELS: Record<InvitationStatus, string> = {
  [InvitationStatus.PENDING]: 'Ожидает',
  [InvitationStatus.ACCEPTED]: 'Принято',
  [InvitationStatus.REVOKED]: 'Отозвано',
  [InvitationStatus.EXPIRED]: 'Истекло',
};

export const INVITATION_STATUS_TONES: Record<InvitationStatus, Tone> = {
  [InvitationStatus.PENDING]: 'caution',
  [InvitationStatus.ACCEPTED]: 'positive',
  [InvitationStatus.REVOKED]: 'negative',
  [InvitationStatus.EXPIRED]: 'neutral',
};

/** TZ §18 — ledger operation names as the player should read them. */
export const LEDGER_TYPE_LABELS: Record<LedgerTransactionType, string> = {
  [LedgerTransactionType.ADMIN_DEPOSIT]: 'Пополнение администратором',
  [LedgerTransactionType.ADMIN_WITHDRAWAL]: 'Списание администратором',
  [LedgerTransactionType.BET_ENTRY]: 'Участие в матче',
  [LedgerTransactionType.ROUND_WIN]: 'Выигрыш по розыгрышу',
  [LedgerTransactionType.REFUND]: 'Возврат',
  [LedgerTransactionType.ROUND_REFUND]: 'Возврат по розыгрышу',
  [LedgerTransactionType.REVERSAL]: 'Сторнирование',
  [LedgerTransactionType.MANUAL_ADJUSTMENT]: 'Ручная корректировка',
};

/** TZ §19 */
export const PLATFORM_LEDGER_TYPE_LABELS: Record<PlatformLedgerTransactionType, string> = {
  [PlatformLedgerTransactionType.COMMISSION]: 'Комиссия платформы',
  [PlatformLedgerTransactionType.ROUNDING_REMAINDER]: 'Остаток округления',
  [PlatformLedgerTransactionType.REVERSAL]: 'Сторнирование',
  [PlatformLedgerTransactionType.MANUAL_ADJUSTMENT]: 'Ручная корректировка',
};

export const CALCULATION_STATUS_LABELS: Record<CalculationStatus, string> = {
  [CalculationStatus.COMPLETED]: 'Выполнен',
  [CalculationStatus.REVERSED]: 'Сторнирован',
};

export const CALCULATION_STATUS_TONES: Record<CalculationStatus, Tone> = {
  [CalculationStatus.COMPLETED]: 'positive',
  [CalculationStatus.REVERSED]: 'negative',
};

/** TZ §15 — full-refund settlements are never framed as a loss. */
export const SETTLEMENT_STATUS_LABELS: Record<SettlementResultStatus, string> = {
  [SettlementResultStatus.WINNERS]: 'Есть победители',
  [SettlementResultStatus.NO_WINNER]: 'Исход не угадан — возврат',
  [SettlementResultStatus.SINGLE_PARTICIPANT]: 'Единственный участник — возврат',
};

export const OUTCOME_LABELS: Record<MatchOutcome, string> = {
  [MatchOutcome.HOME_WIN]: 'Победа хозяев',
  [MatchOutcome.DRAW]: 'Ничья',
  [MatchOutcome.AWAY_WIN]: 'Победа гостей',
};

export const OUTCOME_SHORT_LABELS: Record<MatchOutcome, string> = {
  [MatchOutcome.HOME_WIN]: 'П1',
  [MatchOutcome.DRAW]: 'Х',
  [MatchOutcome.AWAY_WIN]: 'П2',
};
